module.exports = __webpack_public_path__ + "img/gh--12132.asm.8a4f3199.jpg";